import React, { useContext, useState } from 'react';
import AppContext from "../../AppContext";


const Password = ({pw}) => {
  const [input, setInput] = useState("");
  const [valid, setValid] = useState(true);
  const { setPasswordEntered } = useContext(AppContext);
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input !== pw) {
      setValid(false);
      setPasswordEntered(false);
    } else {
      setValid(true);
      setPasswordEntered(true);
      localStorage.setItem('passwordEntered', true);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/75">
      <div className="w-full max-w-sm rounded-lg bg-white p-8 shadow-xl">
        <h2 className="text-center text-lg font-semibold text-gray-900">
          Enter Password
        </h2>

        <form onSubmit={handleSubmit} className="mt-6">
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600"
            placeholder="Password"
          />

          {!valid && (
            <p className="mt-2 text-sm text-red-600">Incorrect password</p>
          )}

          <button
            type="submit"
            className="mt-4 w-full rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};
  
export default Password;